<template>
    <div class="web-item-view">
      <img class="item-pic" :src="getImagePath()"/>
      <div class="pic-cover">
        <div class="cover-content">
          <div class="cover-up">
            <div class="dot"></div>
            <div class="dot"></div>
          </div>
          <div class="cover-center">
            <div class="item-price">{{price}}</div>
            <div class="goShopping" v-if="!disable">下载</div>
          </div>
          <div class="cover-down">
            <div class="dot"></div>
            <div class="dot"></div>
          </div>
        </div>
<!--        <div class="cover-up">-->
<!--          <div class="dot"></div>-->
<!--          <div class="dot"></div>-->
<!--        </div>-->

<!--        <div class="cover-center">-->
<!--          <div class="dot"></div>-->
<!--          <div class="dot"></div>-->
<!--        </div>-->
<!--        <div class="cover-down">-->
<!--          <div class="dot"></div>-->
<!--          <div class="dot"></div>-->
<!--        </div>-->
<!--        <div class="dot"></div>-->
<!--        <div class="item-price">test</div>-->
      </div>
      <div class="item-content">{{item}}</div>
    </div>
</template>

<script>
var path1 = require('../assets/item1.jpg')
var path2 = require('../assets/item2.jpg')
var path3 = require('../assets/item3.jpg')
var path4 = require('../assets/item4.jpg')
var path5 = require('../assets/item5.jpg')
var path6 = require('../assets/item6.jpg')

export default {
  name: 'web-item',
  props: {
    item: {
      type: String,
      default: ''
    },
    imgIndex: {
      type: Number,
      default: 0
    },
    price: {
      type: String,
      default: '0'
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getImagePath () {
      switch (this.imgIndex) {
        case 0:
          return path1
        case 1:
          return path2
        case 2:
          return path3
        case 3:
          return path4
        case 4:
          return path5
        case 5:
          return path6
      }
      return path1
    }
  }
}
</script>

<style scoped>
  .web-item-view{
    flex-direction: column;
    justify-content: flex-start;
    align-content: flex-start;
    align-items: flex-start;
    display: flex;
    position: relative;
  }
  .item-pic{
    width: 25.56rem;
    height: 13.5rem;
    flex-shrink: 0;
  }
  .pic-cover{
    width: 25.56rem;
    height: 13.5rem;
    background-color: black;
    opacity: 0;
    position: absolute;
    top: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    align-items: center;
  }
  .pic-cover:hover{
    opacity: 0.8;
  }
  .cover-content{
    width: 95%;
    height: 90%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    /*background-color: red;*/
  }
  .cover-up{
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: flex-start;
    align-items: flex-start;
  }
  .cover-center{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    align-items: center;
  }
  .cover-down{
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
    align-items: center;
  }
  .item-price{
    font-size:2rem;
    font-weight:400;
    line-height:3.25rem;
    color:rgba(255,255,255,1);
  }
  .goShopping{
    width: 6rem;
    height: 2rem;
    background-color: rgba(253,175,0,1);
    font-size:1.13rem;
    font-weight:bold;
    line-height:1.5rem;
    color:rgba(255,255,255,1);
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    align-items: center;
    border-radius: 1rem;
  }
  .item-content{
    width: 25.56rem;
    height: 4.75rem;
    background: black;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    align-items: center;
    display: flex;
    position: relative;
    font-size:1.5rem;
    font-weight:bold;
    line-height:1.94rem;
    color:rgba(255,255,255,1);
  }
  .dot{
    background-color: #c1c1c1;
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/components/web-item.vue